export enum ReservationType {
  Standard = "standard",
  Premium = "premium",
}
